import React, { useCallback, useEffect, useState } from 'react';
import i18n from '../../translations/i18n';
import { themeColors } from '@styles/theme';
import DropDown, { OptionsAlign } from '../DropDown/DropDown';
import { DropDownOptionType } from '../DropDown/Option';
import { getLocalStorageItem } from '../../utils/storageUtils';
import { isReplanApp } from '../../utils/utils';

const LanguageSelector = () => {
    const [langOptionInd, setLangOptionInd] = useState<number>(0);

    const langOptions: DropDownOptionType[] = [
        {
            title: 'En',
            name: 'en-US',
            onClick: () => changeLanguage('en-US'),
        },
        {
            title: 'De',
            name: 'de-DE',
            onClick: () => changeLanguage('de-DE'),
        },
        ...(isReplanApp(window.location.origin)
            ? [{} as DropDownOptionType]
            : [
                  {
                      title: 'Ру',
                      name: 'ru-RU',
                      onClick: () => changeLanguage('ru-RU'),
                  },
              ]),
    ];

    useEffect(() => {
        void (async function () {
            const storedLang = getLocalStorageItem('Replan.i18nextLng');
            await changeLanguage(storedLang);
        })();
    }, []);

    const changeLanguage = useCallback(async (lng: string) => {
        await i18n.changeLanguage(lng);

        const ind = langOptions.findIndex(({ name }) => name === lng);
        if (ind !== -1) {
            setLangOptionInd(ind);
        } else {
            setLangOptionInd(0);
        }
        localStorage.setItem('Replan.i18nextLng', lng);
    }, []);

    return (
        <DropDown
            titleColorLight={themeColors.grey}
            titleColorDark={themeColors.grey3}
            options={langOptions}
            outlined={false}
            selectedOptionInd={langOptionInd}
            optionsAlign={OptionsAlign.RIGHT}
            optionColorLight={themeColors.navyBlue}
            optionColorDark={themeColors.white}
            iconColorDark={themeColors.grey3}
        />
    );
};

export default LanguageSelector;
